import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42f1860b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "horizontal-top-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mnu-bars" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pi pi-align-justify" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "cell-menu top-page-title-short top-page-title-web" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "cell-menu top-page-user-web" }
const _hoisted_7 = { class: "page-container scroll-thin-custom" }

import { onUnmounted, ref, onMounted,PropType } from 'vue';
 import { getAppVersion, traduceTexto } from '@/services/ui/GlobalFunctions';
 import { useServicesFactoryStore }  from '@/store/services-factory-store';
 import { useMainStore } from '@/store/main-store';
 import { eAppPaths, eCommnadsToolbar } from '@/model/GloblasEnum';
 import { Subscription} from "rxjs";
 import { ISesionApp } from '@/model/ISesionApp';
 import menuBurger from '@/components/menuBurger/menuBurger.vue';
 import UserToolbar from '@/views/shared/UserToolbar.vue';
 import CloseSesionView from '@/views/shared/CloseSesionView.vue';
 import { ISesionUsuarios } from '@/model/ISesionUsuarios';
 import {useRoute} from 'vue-router';
 import SecurityManagerService from '@/services/SecurityManagerService';
 import {useWindowChange} from '@/services/ui/WindowChange';
 import { IonPage,IonContent } from '@ionic/vue';
 
 
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeWebContent',
  props: { 
  sesionApp: {type:Object as PropType<ISesionApp>, required:true},
  menus: { type: Array as PropType<any>, required:true },
  hubSesion: { type: Object as PropType<ISesionUsuarios>, required:true }
 },
  setup(__props) {

 const labels = {ajustesLabel: traduceTexto('globals.appOptionsComponent')
 };
 const props = __props;
 const loginService = useServicesFactoryStore().getLoginService;
 const routeService = useServicesFactoryStore().getRouteService;
 const uiManager = useServicesFactoryStore().getUIManager;
 const securityService:SecurityManagerService = useServicesFactoryStore().getSecurityManagerService;
 const version = getAppVersion();
 const menuIsOpen = ref(false);
 const {screen} = useWindowChange();
 //const isMobile = ref(useWindowChange().screen.value.IsMobile);
 const route = useRoute();
 const h = traduceTexto('globals.closesesion');
 const m = traduceTexto('globals.mesageclosesesion');
 let ActiveMenu = ref<any>(null);
 let ActiveMenuSubscription: Subscription;
 const openMenu = () =>
 {
     menuIsOpen.value = !menuIsOpen.value;
 }
 const onClickMenu = () =>
 {
   menuIsOpen.value = false;
 }
 const closeSesion = async () =>
 {    
     uiManager.showConfirm(h,m, async()=>
     {
         await loginService.CloseSesion(props.sesionApp);   
         useMainStore().closeSesionApp();
         routeService.go(eAppPaths.login);
     },null);
 }
 const onCommand = async (command:any)=>
 {
     switch(command.type)
     {
         case eCommnadsToolbar.logof:
             await closeSesion();
             break;
         case eCommnadsToolbar.options:
             await uiManager.showShortAppSettings(labels.ajustesLabel);
             break;
         case eCommnadsToolbar.reload:            
             uiManager.reloadCurrentByAction();
             break;
     }    
 }
 const findMenuByRoute = () =>
 {
     if(!route) return ;    
     const routeName = route.name? route.name.toString():'';    
     const menu = securityService.getMenuByName2(props.sesionApp,routeName);
     if(menu)    
         uiManager.ActiveMenu.next(menu);    
 }
 onMounted(()=>
 {        
     ActiveMenuSubscription = uiManager.ActiveMenu.subscribe((activeMenu: any) => 
     {        
        if(activeMenu)
         ActiveMenu.value = activeMenu;       
        else
         findMenuByRoute();
     });    
 }); 
 onUnmounted(()=>
 {
     if (ActiveMenuSubscription)
     {
         ActiveMenuSubscription.unsubscribe();
     }
 });
 
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "page-full-container",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (menuIsOpen.value=false))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "cell-menu cell-menu-ico",
            onClick: _withModifiers(openMenu, ["stop","prevent"])
          }, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            (_unref(ActiveMenu) && _unref(ActiveMenu).data && _unref(ActiveMenu).data.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t(`menus.${_unref(ActiveMenu).data.title}`)), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(UserToolbar, {
              tipo: 1,
              sesionApp: __props.sesionApp,
              hubSesion: __props.hubSesion,
              onOnCommand: onCommand
            }, null, 8, ["sesionApp", "hubSesion"])
          ])
        ]),
        _createVNode(_unref(IonContent), { class: "ionContentweb" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["menu-page page-panel-main", {'menuIsOpen':menuIsOpen.value,'menuIsNoOpen':!menuIsOpen.value,'menu-page-movil':_unref(screen).IsMobile}])
            }, [
              _createElementVNode("div", {
                class: "menu",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
              }, [
                _createVNode(menuBurger, {
                  go: true,
                  menus: __props.menus,
                  onOnClickMenu: onClickMenu
                }, null, 8, ["menus"]),
                _createVNode(CloseSesionView, {
                  version: _unref(version),
                  onOnClose: closeSesion
                }, null, 8, ["version"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ], 2)
          ]),
          _: 3
        })
      ])
    ]),
    _: 3
  }))
}
}

})